import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useParams } from 'react-router-dom';
import { apiAction, generalSet } from '../../store/generalSlice';
import Spinner from '../../layout/Spinner';

const GeneralSetting = () => {
  const dispatch = useDispatch();
  const { generalSetting_id } = useParams();

  const { generalSetting } = useSelector((state) => state.general);

  const [changes, setChanges] = useState({});

  useEffect(() => {
    dispatch(
      apiAction({
        reduxField: 'generalSetting',
        route: `generalSettings/getGeneralSettingsById`,
        id: generalSetting_id,
      })
    );
  }, [dispatch, generalSetting_id]);

  if (generalSetting?._id !== generalSetting_id) {
    dispatch(
      generalSet({
        reduxField: 'generalSetting',
        value: null,
      })
    );
  }

  const handleSaveChanges = () => {
    dispatch(
      apiAction({
        route: 'generalSettings/changeGeneralSettings',
        reduxField: 'generalSetting',
        id: generalSetting_id,
        changes,
      })
    );
    setChanges({});
  };
  console.log({ generalSetting, changes });
  return generalSetting?._id ? (
    <>
      <div>
        <Link className='btn btn-outline-dark' to='/generalSettings'>
          Back to General Settings
        </Link>
      </div>
      <div className='container mb-4' data-aos='fade-up' data-aos-delay='200'>
        <div className='row d-flex justify-content-center pt-4 pt-lg-0'>
          <div className='col-lg-12 d-flex justify-content-center mt-4 pt-lg-0'>
            <h1>General Settings</h1>
          </div>
        </div>
        <div className='row d-flex justify-content-center pt-4 pt-lg-0'>
          <div className='col-lg-8 mt-4 pt-lg-0'>
            <label>General Setting Name</label>

            <input
              type='text'
              style={{ textAlign: 'center' }}
              className='form-control'
              defaultValue={generalSetting.name}
              onChange={(e) => setChanges({ ...changes, name: e.target.value })}
            />
            {changes.name ? (
              <button className='btn btn-outline-success' onClick={() => handleSaveChanges()}>
                Save
              </button>
            ) : null}
          </div>
          <div className='col-lg-6 mt-4 pt-lg-0'>
            <label>Spend Disrepancy Percentage</label>
            <input
              type='number'
              style={{ textAlign: 'center' }}
              className='form-control'
              defaultValue={generalSetting.spendDisPercentage}
              onChange={(e) => setChanges({ ...changes, spendDisPercentage: e.target.value })}
            />
            {changes.spendDisPercentage ? (
              <button className='btn btn-outline-success' onClick={() => handleSaveChanges()}>
                Save
              </button>
            ) : null}
          </div>
          <div className='col-lg-6 mt-4 pt-lg-0'>
            <label>Rule Frequency</label>
            <input
              type='number'
              style={{ textAlign: 'center' }}
              className='form-control'
              defaultValue={generalSetting.ruleFrequency}
              onChange={(e) => setChanges({ ...changes, ruleFrequency: e.target.value })}
            />
            {changes.ruleFrequency ? (
              <button className='btn btn-outline-success' onClick={() => handleSaveChanges()}>
                Save
              </button>
            ) : null}
          </div>
        </div>
        <div className='row d-flex justify-content-center pt-4 pt-lg-0 mt-4 border p-2'>
          <div className='col-md-12 d-flex justify-content-center'>
            <h3>Validate Budget Status</h3>
          </div>
          <div className='col-md-12 d-flex justify-content-center'>
            <small>Determends if "Change Budget" actions should validate the budget before proceeding</small>
          </div>
          <div className='col-md-12 d-flex justify-content-center mt-2'>
            <input
              type='checkbox'
              checked={generalSetting.validateBudgetStatus}
              onChange={(e) => {
                dispatch(
                  apiAction({
                    route: 'generalSettings/changeGeneralSettings',
                    reduxField: 'generalSetting',
                    id: generalSetting_id,
                    changes: { validateBudgetStatus: e.target.checked },
                  })
                );
              }}
            />{' '}
            {generalSetting.validateBudgetStatus ? (
              <span className='ml-2 text-primary'>Enabled</span>
            ) : (
              <span className='ml-2 text-danger'>Disabled</span>
            )}
          </div>
        </div>
        <div className='row d-flex justify-content-center pt-4 pt-lg-0 mt-4'>
          <div className='col-md-12 d-flex justify-content-center border-bottom'>
            <h3>Webhooks URIs</h3>
          </div>
          <div className='col-md-12 mt-4 pt-lg-0'>
            <label>GENERATE_IMAGE_MAKE</label>
            <input
              type='text'
              style={{ textAlign: 'center' }}
              className='form-control'
              defaultValue={generalSetting.makeWebhookGenerateImage}
              onChange={(e) => setChanges({ ...changes, makeWebhookGenerateImage: e.target.value })}
            />
            {changes.makeWebhookGenerateImage ? (
              <button className='btn btn-outline-success' onClick={() => handleSaveChanges()}>
                Save
              </button>
            ) : null}
          </div>
        </div>
      </div>
    </>
  ) : (
    <Spinner />
  );
};

export default GeneralSetting;
